import { createSlice } from "@reduxjs/toolkit";
import type {
  PersonalInfoRecord,
  IdentificationRecord,
  LicOtherPolicyRecord,
  LicNomineeRecord,
  LicHealthRecord,
  LicLegalRecord,
  LicDetailRecord,
  LicDocumentRecord,
  LicDocumentTypeRecord,
} from "services/kycService";

export const initialState = {
  proposalId: null as number | null,
  licId: null as number | null,
  employmentId: null as number | null,
  legalId: null as number | null,
  healthId: null as number | null,
  nomineeId: null as number | null,
  otherPolicyId: null as number | null,
  documentId: null as number | null,
  identificationId: null as number | null,
  employmentData: [] as any[],
  personalInfoData: null as PersonalInfoRecord | null,
  identificationData: null as IdentificationRecord | null,
  otherPolicyData: [] as LicOtherPolicyRecord[],
  nomineeData: [] as LicNomineeRecord[],
  healthData: [] as LicHealthRecord[],
  legalData: [] as LicLegalRecord[],
  documentData: [] as LicDocumentRecord[],
  documentTypeData: [] as LicDocumentTypeRecord[],
  licDetailData: null as LicDetailRecord | null,
  proposalList: null as { proposals: any[]; pagination?: { page?: number; total?: number; total_pages?: number; per_page?: number } } | null,
  loadingProposals: false,
  loading: false,
  successMsg: {
    message: "",
    id: 0,
  },
  errorMsg: {
    message: "",
    id: 0,
  },
};

const kycSlice = createSlice({
  name: "kyc",
  initialState,
  reducers: {
    setProposalId(state, action) {
      state.proposalId = action.payload;
    },
    setLicId(state, action) {
      state.licId = action.payload;
    },
    setEmploymentId(state, action) {
      state.employmentId = action.payload;
    },
    setEmploymentData(state, action) {
      state.employmentData = action.payload;
    },
    setLegalId(state, action) {
      state.legalId = action.payload;
    },
    setHealthId(state, action) {
      state.healthId = action.payload;
    },
    setNomineeId(state, action) {
      state.nomineeId = action.payload;
    },
    setOtherPolicyId(state, action) {
      state.otherPolicyId = action.payload;
    },
    setDocumentId(state, action) {
      state.documentId = action.payload;
    },
    setDocumentData(state, action) {
      state.documentData = action.payload;
    },
    setIdentificationId(state, action) {
      state.identificationId = action.payload;
    },
    setDocumentTypeData(state, action) {
      state.documentTypeData = action.payload;
    },
    setPersonalInfoData(state, action) {
      state.personalInfoData = action.payload;
    },
    setIdentificationData(state, action) {
      state.identificationData = action.payload;
    },
    setOtherPolicyData(state, action) {
      state.otherPolicyData = action.payload;
    },
    setNomineeData(state, action) {
      state.nomineeData = action.payload;
    },
    setHealthData(state, action) {
      state.healthData = action.payload;
    },
    setLegalData(state, action) {
      state.legalData = action.payload;
    },
    setLicDetailData(state, action) {
      state.licDetailData = action.payload;
    },
    /** Clear all stepper IDs when opening create flow (no proposal_id). */
    resetStepperIds(state) {
      state.proposalId = null;
      state.licId = null;
      state.identificationId = null;
      state.employmentId = null;
      state.otherPolicyId = null;
      state.nomineeId = null;
      state.healthId = null;
      state.legalId = null;
      state.documentId = null;
      state.employmentData = [];
      state.identificationData = null;
      state.otherPolicyData = [];
      state.nomineeData = [];
      state.healthData = [];
      state.legalData = [];
      state.documentData = [];
      state.personalInfoData = null;
      state.licDetailData = null;
    },
    setProposalList(state, action) {
      state.proposalList = action.payload;
    },
    setLoadingProposals(state, action) {
      state.loadingProposals = action.payload;
    },
    setLoader(state, action) {
      state.loading = action.payload;
    },
    successMsg(state, action) {
      state.successMsg.message = action.payload.message;
      state.successMsg.id = action.payload.id;
    },
    errorMsg(state, action) {
      state.errorMsg = action.payload;
    },
  },
});

export const {
  setProposalId,
  setLicId,
  setEmploymentId,
  setLegalId,
  setHealthId,
  setNomineeId,
  setOtherPolicyId,
  setDocumentId,
  setDocumentData,
  setIdentificationId,
  setDocumentTypeData,
  setEmploymentData,
  setPersonalInfoData,
  setIdentificationData,
  setOtherPolicyData,
  setNomineeData,
  setHealthData,
  setLegalData,
  setLicDetailData,
  resetStepperIds,
  setProposalList,
  setLoadingProposals,
  setLoader,
  successMsg,
  errorMsg,
} =
  kycSlice.actions;

export default kycSlice.reducer;
